module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("add9q"))).then(() => parcelRequire('ljYL6'));